import React from 'react';
import PropTypes from 'prop-types';
import PageTitle from '../components/PageTitle';
import Layout from '../containers/Layout';
import Button from '../components/Button';
import Wrapper from '../components/Wrapper';
import { connect } from 'react-redux';
import { loginAction } from '../redux/user';

const Login = ({ authorize }) => (
  <Layout>
    <PageTitle messageId="app.login" />
    <div style={{ padding: '100px 0', width: '100%' }}>
      <Wrapper>
        <Button messageId="app.login" onClick={authorize} />
      </Wrapper>
    </div>
  </Layout>
);

Login.propTypes = {
  authorize: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  authorize: () => dispatch(loginAction()),
});

export default connect(undefined, mapDispatchToProps)(Login);
